import { LoginCallback } from '@okta/okta-react';
import React from 'react';

const OktaLoginCallback = () => {
  return typeof window !== 'undefined' && <LoginCallback />;
};

export default OktaLoginCallback;
